import { ErrorHandler, Injector } from '@angular/core';
import { ToastDataHelper } from 'app/shared/models/b2b/toastData';
import { EventsService } from 'app/shared/services/utils/events.service';
import * as Sentry from '@sentry/angular';
import { AppState } from 'app/store';
import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';
import { env } from '../../../../../env';

export class CustomErrorHandler extends Sentry.SentryErrorHandler implements ErrorHandler {
    private store: Store<AppState> | null = null;

    constructor(
        private injector: Injector,
        private eventsService: EventsService
    ) {
        super();
    }

    private getStore(): Store<AppState> {
        if (!this.store) {
            this.store = this.injector.get(Store);
        }
        return this.store;
    }

    handleError(error: any) {
        // Mostrar toast al usuario inmediatamente
        this.eventsService.broadcast('showToast', ToastDataHelper.create({ type: 'error', text: error.message }));
        console.error(error);

        // Obtener el usuario del store de forma lazy para evitar dependencias circulares
        if (env.production) {
            try {
                const store = this.getStore();
                store
                    .select((state) => state.user.data)
                    .pipe(take(1))
                    .subscribe((user) => {
                        if (user) {
                            Sentry.setUser(user);
                        }
                        super.handleError(error);
                    });
            } catch (e) {
                // Si el store no está disponible, reportar el error sin contexto de usuario
                console.warn('No se pudo obtener el store:', e);
                super.handleError(error);
            }
        }
    }
}
